import React from 'react';
import { Label } from '../elements/Label';
import PropTypes from 'prop-types';

export default class FormInput extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			hasError: false
		}
	}

	handleBlur = (e) => {
		let result = this.props.handleChange(e, this.props.type, this.props.field);
		this.setState({hasError: result});
	};

	render() {
		const style = {
			borderBottom: `2px solid ${ this.props.inputStyle }`
		};

		return (
			<div className="form-input">
				{this.props.label && <Label content={this.props.label}/>}
				<input placeholder={this.props.placeholder} onBlur={this.handleBlur} type={this.props.type} style={style}/>
				{this.state.hasError && <div className="form-input__error">Error, please enter a valid {this.props.type}</div>}
			</div>
		);
	}
};

FormInput.propTypes = {
	label: PropTypes.string,
	handleChange: PropTypes.func,
	type: PropTypes.string,
	placeholder: PropTypes.string,
	//hasError
};

FormInput.defaultProps = {
	type: 'text'
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/elements/FormInput.js